import { RecentlyUsedVideo } from './types';
/**
 * Appends the currently-active intro/outro URL to the list if it is not already
 * present. Used to surface a video that is still set on the clip but has been
 * removed from the brand kit store. Marked non-deletable since there is nothing
 * left in the store to remove.
 */
export function appendActiveVideoIfMissing(list: RecentlyUsedVideo[], currentUrl: string | undefined): void {
  if (currentUrl && currentUrl.includes('brand_kit') && !list.find(v => v.url === currentUrl)) {
    list.push({ url: currentUrl, name: currentUrl, deletable: false });
  }
}
